import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_API_HOST

export default {
  async getCompanyInfo(id) {
    try {
      const response = await axios.get(`/companies/${id}`)
      console.log(response)
      return response
    } catch (error) {
      throw new Error(error.response.data.message)
    }
  },
  async getRoutesByCompany(id) {
    try {
      const response = await axios.get(`/routes/company/${id}/routes`)
      console.log(response)
      return response
    } catch (error) {
      throw new Error(error.response.data.message)
    }
  },
  async getDriver(id) {
    try {
      const response = await axios.get(`/users/users/${id}`)
      return response
    } catch (error) {
      throw new Error(error.response.data.message)
    }
  },
  async getReviewsByDriver(id) {
    try {
      const response = await axios.get(`/reviews/${id}`)
      return response
    } catch (error) {
      throw new Error(error.response.data.message)
    }
  },
  async postReview(review) {
    try {
      const response = await axios.post('/reviews', review)
      return response
    } catch (error) {
      throw new Error(error.response.data.message)
    }
  }
}
